<template>

      <v-card
        class="mx-auto"
        max-width="1000"
        min-width="300"
      >
        <v-toolbar class="pencil"  :color="ToolColor" dark @click="Loadin();Hide = !Hide">
          <v-toolbar-title>{{ Headline }}</v-toolbar-title>

          <v-toolbar-side-icon color="white darken-1">
            <v-icon v-if="Hide == false" color="orange ligthen-1" >arrow_downward</v-icon>
            <v-icon v-else color="orange ligthen-1">arrow_upward</v-icon>
          </v-toolbar-side-icon>

          <v-spacer></v-spacer>
        </v-toolbar>
        
  <v-expand-transition >
        <div  v-if="Hide">
  <NewAP :schoolId="schoolId" :id="id"  v-model="dialogClass" :classesnameandId="classesnameandId"   :teachernameandId="teachernameandId" />

     <div  v-if="APs.length!=0">
       
  <NewAP :schoolId="schoolId" :id="id"  v-model="dialog" :Oldclass="Class" :classesnameandId="classesnameandId" :teachernameandId="teachernameandId" />
    <v-flex justify="center">
      <v-dialog v-model="dialogAccess" persistent max-width="600px">



    <v-toolbar
      color="indigo"
      dark
    >
      <v-toolbar-title class="headline"> Åtkomst åtgärdsprogram för {{accessItem.name }} 
            <v-icon dark @click="showTipSnackbar('Här kan du se vilka som har åtkomst till dokumentet samt när/om de öppnat det.')"> info </v-icon></v-toolbar-title>
    </v-toolbar>
    <v-list>
          <v-list-tile
            v-for="item in accessItem.items"
        :key="item.name"
            avatar
          >
            <v-list-tile-action>
              <v-icon
            v-if="item.icon=='mentor'"
            color="pink"
          >
            star
          </v-icon>
         <v-icon
            v-else-if="item.icon=='teacher'"
            color="pink"
          >
            school
          </v-icon>
                   <v-icon
            v-else
            color="pink"
          >
            engineering
          </v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title  v-text="locfun.getName(
             item.name,
              teachernameandId,
              []
            )"   ></v-list-tile-title>
          <v-list-tile-sub-title >{{item.time}}</v-list-tile-sub-title>
                       
            </v-list-tile-content>


          </v-list-tile>  
          
                       <v-spacer></v-spacer>
            <v-btn dark color="blue darken-1" @click="dialogAccess = false">
              Stäng
            </v-btn>
        </v-list>

     
      </v-dialog>
<RemoveWindow 
        v-model="dialogDelete"   Type="AP" :removeItem="removeItem"  Headline="Ta bort åtgärdsprogram för" WarningText="Är du säker på att du vill ta bort detta åtgärdsprogramet från EHTKollen? Ett åtgärdsprogram som är
              borttagen går inte att återfå utan måste länkas om på nytt. Dokumentet är dock kvar på filservern där länken är tagen ifrån."    />
       </v-flex>
                   <v-text-field
          v-model="search"
          label="Sök efter åtgärdsprogram/utredning"
          class="mx-4"
        ></v-text-field>
    <v-data-table
      :headers="headers.filter(head=> head.access==this.role ||!head.hasOwnProperty('access') )"
      :items="APs"
      item-key="name"
      sort-by="name"
      class="elevation-1"      
      :pagination.sync="pagination"
      :search="search"
      show-group-by
    >
      <template v-slot:items="props">
        <td class="text-xs-right">{{ props.item.name }}</td>
        <td class="text-xs-right">
          <div v-if="Array.isArray(props.item.link)==true">
                        
                        <v-tooltip  bottom v-for="(link,index) in props.item.link" :key="index">
            

      <template v-slot:activator="{ on, attrs }">
                    <v-btn  
            class="mx-2"
            fab
            dark
                       v-bind="attrs"  v-on="on"
            small
            @click="openLink(props.item,index)"
            color="purple ligthen-1"
          >
            <v-icon dark> wysiwyg </v-icon>
          </v-btn>
          
           </template>      <span>{{link.title}}</span>    </v-tooltip>
          </div>
          <div v-else>
            <!-- //Temporär tills jag gjort om alla till arrayer!-->
               <v-btn  
            class="mx-2"
            fab
            dark
            small
            @click="openLink(props.item,index)"
            color="purple ligthen-1"
          >
            <v-icon dark> wysiwyg </v-icon>
          </v-btn>
          </div>

          </td>
        <td class="text-xs-right">{{ getClass(props.item.class) }}</td>
        <td class="text-xs-right" v-if="role=='eht'">
          
                    <v-btn
            class="mx-2"
            dark
            small
            @click="openAccess(props.item)  
            "
            color="pink ligthen-1"
          >
           {{getAccesstype( props.item.accessType) }}
          </v-btn>
         </td>
        <td class="text-xs-right">          
          {{
            locfun.getName(
              props.item.uploader,
              [],
              membernameandId
            )
          }}
        </td>

         <td class="text-xs-right"  v-if="role=='eht'">
                  {{  props.item.hasOwnProperty('createDate') ?    locfun.getDate(
              props.item.createDate
            ): 'Ingen data att visa' }} 
        </td>


         <td class="text-xs-right">
                 {{  props.item.hasOwnProperty('startDate') ?    locfun.getDate(
              props.item.startDate
            ): 'Ingen data att visa' }} 
        </td>

         <td class="text-xs-right">
              {{  props.item.hasOwnProperty('endDate') ?    locfun.getDate(
              props.item.endDate
            ): 'Ingen data att visa' }} 
        </td>
                 <td class="text-xs-right"  v-if="role=='eht'">

                   {{   props.item.hasOwnProperty('uploadDate') ?    locfun.getDate(
              props.item.uploadDate
            ) : 'Ingen data att visa' }}   
        </td>
                 <td class="text-xs-right">
         {{   props.item.hasOwnProperty('expireDate') ? locfun.getDate(
              props.item.expireDate
            )  : 'Länken är inte tidsbestämd' }}   {{
           
          }}
        </td>
        <td v-if="role!='teacher'" class="text-xs-right">
          <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="
              Class=props.item;dialog = true;
            "
            color="green ligthen-1"
          >
            <v-icon dark> upgrade </v-icon>
          </v-btn>
        </td>
        <td class="text-xs-right" v-if="role!='teacher'">
  <v-btn
            class="mx-2"
            fab
            dark
            small
            @click="
              removeItem = props.item;
              dialogDelete = true;
            "
            color="red ligthen-1"
          >
            <v-icon dark> clear </v-icon>
          </v-btn>
        </td>

      </template>
            <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
         Det finns inget resultat för din sökning på "{{ search }}". 
        </v-alert>
      </template>
    </v-data-table>
         <div class="text-xs-center pt-2">
      <v-btn color="light-blue darken-1" dark @click="toggleOrder">Ändra sorteringsordning</v-btn>
      <v-btn color="light-blue darken-1" dark @click="nextSort">Sortera på nästa kolumn</v-btn>
    </div>
                 <v-btn
      class="mx-2"
      dark
      @click="dialogClass=true"
      color="green darken-1"
    >
      Lägg till ett åtgärdsprogram
    </v-btn>
  </div>
      <div v-else  class="bellowPen" :class="ToolColor+ ' lighten-2 text-center'">  
    <span class="tt" color="white">Det finns inga Återgärdsprogram än.</span>
                <v-btn
      class="mx-2"
      dark
      @click="dialogClass=true"
      color="green darken-1"
    >
      Lägg till ett åtgärdsprogram
    </v-btn>
    </div>
        </div>
  </v-expand-transition>
      </v-card>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import fun from "../functions";
import NewAP from "./NewAP";
import RemoveWindow from "../assets/RemoveWindow";
export default {
  name: "AP",
  components: {
    NewAP,RemoveWindow
  },
  props: {
    // content: Array,
    Headline: String,
    ToolColor: String,
    schoolId: String,
    role: String,
    id: String,
    
  },

  watch: {
  },
  created() {
    this.locfun = new fun();
//   }
  },
  computed: {
    ...mapGetters("teachers", ["teachernameandId"]),
    ...mapGetters("ehtmembers", ["membernameandId"]),
    ...mapGetters("classesAP", ["classesnameandId",'classes','APs','APsFetched']),
    
  },
  methods: {

    ...mapActions("classesAP", ["initAPs","initAPsforMe"]),
    ...mapActions(['showTipSnackbar']),

    Loadin()
    {
        if (this.APsFetched==false) {
      if(this.role=="teacher") //Klar för lärare men inte eht
      {
     
      let data={schoolId:this.schoolId,id:this.id}
        if (this.classes.length!=0) {
          data.classes = this.classes
   
      //console.log("Fetched");   
    this.initAPsforMe(data)
}  

      }
      else
       {
         
      //console.log("Fetched");   
         this.initAPs(this.schoolId)
       }
      }

    },

getAccesstype(typ)
{
  
  if (typ=="all") {
  return "Alla lärare"
  }
  else if (typ=="mentor") {
  return "Bara mentor"
  }
  else if (typ=="teacher") {
  return "Lärare & mentor"
  }
  else if (typ=="spec") {
  return "Viss personal"
  }
  return typ;
},

    getClass(Classid)
    {
//  (Classid)
//  (this.classes)
 let Class= this.classes.find(element => element.id ==Classid); 
//   (Class)
 if (Class=== undefined) {
   return ""
 }
 return Class.name;
    },
 
    toggleOrder () {
        this.pagination.descending = !this.pagination.descending
      },
      nextSort () {
        let index = this.headers.findIndex(h => h.value === this.pagination.sortBy)
        index = (index + 1) % this.headers.length
        index = index === 0 ? index + 1 : index
        this.pagination.sortBy = this.headers[index].value
      },

IsOpen(AP,id)
{
  if (AP.hasOwnProperty('openedLink')) {
    

      let openedTime= AP.openedLink.find(teacher => teacher.id == id);
    if (openedTime==undefined) {
      return "Inte öppnad"
    }
    else
    return "Öppnat "+this.locfun.getDate(openedTime.time)
      }
        return "Inte öppnad"
},

openAccess(Case){
 let Class= this.classes.find(element => element.id == Case.class); 
//  //console.log(Class)
//  //console.log(Case)
  this.accessItem.items= [];
// if (Case.accessType=="mentor" ||Case.accessType=="all"  ||Case.accessType=="teacher"  ) {
if (Case.accessType!="spec") {
  if (Class.hasOwnProperty('mentorIds'))
  Class.mentorIds.forEach(element => {
    
     this.accessItem.items.push({name:element, icon:"mentor", time:this.IsOpen(Case,element)})
  });
}
if (Case.accessType=="all" ||Case.accessType=="teacher") {
  
  if (Class.hasOwnProperty('teacherIds'))
  Class.teacherIds.forEach(element => {
     this.accessItem.items.push({name:element, icon:"teacher", time:this.IsOpen(Case,element)})
  });
}
if (Case.accessType=="spec") {
  
  if (Class.hasOwnProperty('specAccess'))
  Case.specAccess.forEach(element => {
     this.accessItem.items.push({name:element
     , time:this.IsOpen(Case,element)})
  });
} 
// // (this.accessItem)
 this.accessItem.name = Case.name;
 this.dialogAccess = true;
},
openLink(item,nr){
  if (this.role=="teacher") {
    if (!item.hasOwnProperty('openedLink')) {
      item.openedLink=[]
    }
   if(undefined==item.openedLink.find(element => element.id == this.id))
   {
    item.openedLink.push({id:this.id,time: Date.now()})
    this.saveAP(item);
   }

  }
          window.open(item.link[nr].link, "_blank");  
},
    ...mapActions("classesAP", ["removeAP",'saveAP']),
    ...mapActions(["showSuccessSnackbar"]),
  },
  data() {
    return {
      
      search: '',
            pagination: {
          sortBy: 'steps[0].starttime'
        },
      removeItem: { name: "temp", id: "temp" },
      accessItem: { name: "temp", id: "temp" },
      dialogDelete: false,
      dialogAccess: false,
      dis: {},
      dialog: false,
      dialogClass: false,
      Class: null,
      Choosen: null,
      Hide: false,
      headers: [
        {
          text: "Elevnamn",
          align: "start",
          value: "name"
        },
        { text: "Länk", value: "link", align: "right" },
        { text: "Klass", value: "class", align: "right" },
        { text: "Åtkomst & info", value: "accesstype", align: "right"  , access:"eht"},
        { text: "Uppladdare", value: "uploader", align: "right" },
        { text: "Skapad", value: "createDate", align: "right" , access:"eht"},
        { text: "Startdatum", value: "startDate", align: "right" },
        { text: "Slutdatum", value: "endDate", align: "right" },
        { text: "Uppladdat", value: "uploadDate", align: "right", access:"eht" },
        { text: "Utgår", value: "expireDate", align: "right" },
        { text: "Ändra", value: "ändra", align: "right" , access:"eht" },
        { text: "Ta bort", value: "tabort", align: "right" , access:"eht"},
      ],
    };
  },
};
</script>